/**
 * @generated SignedSource<<a6a3cb8a5f29c0b0aa6a6f1349f10f3e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ActivitySource = "CABANA" | "SIPGATE" | "STRIPE" | "ZAMMAD" | "%future added value";
export type ContactActivityViewQuery$variables = {
  contactIdentifier: string;
  first?: number | null | undefined;
  offset?: number | null | undefined;
};
export type ContactActivityViewQuery$data = {
  readonly contactActivities: {
    readonly activities: ReadonlyArray<{
      readonly actorName: string | null | undefined;
      readonly body: string | null | undefined;
      readonly id: string;
      readonly metadata: any;
      readonly occurredAt: any;
      readonly source: ActivitySource;
      readonly type: string;
    }>;
    readonly hasMore: boolean;
    readonly totalCount: number;
  };
};
export type ContactActivityViewQuery = {
  response: ContactActivityViewQuery$data;
  variables: ContactActivityViewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contactIdentifier"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "first"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "offset"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "contactIdentifier",
        "variableName": "contactIdentifier"
      },
      {
        "kind": "Variable",
        "name": "first",
        "variableName": "first"
      },
      {
        "kind": "Variable",
        "name": "offset",
        "variableName": "offset"
      }
    ],
    "concreteType": "ActivityResult",
    "kind": "LinkedField",
    "name": "contactActivities",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Activity",
        "kind": "LinkedField",
        "name": "activities",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "source",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "type",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "occurredAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "metadata",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "actorName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "body",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "totalCount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hasMore",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ContactActivityViewQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ContactActivityViewQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "75eb93ee5f71b3199ce4953fbc58563e",
    "id": null,
    "metadata": {},
    "name": "ContactActivityViewQuery",
    "operationKind": "query",
    "text": "query ContactActivityViewQuery(\n  $contactIdentifier: ID!\n  $first: Int\n  $offset: Int\n) {\n  contactActivities(contactIdentifier: $contactIdentifier, first: $first, offset: $offset) {\n    activities {\n      id\n      source\n      type\n      occurredAt\n      metadata\n      actorName\n      body\n    }\n    totalCount\n    hasMore\n  }\n}\n"
  }
};
})();

(node as any).hash = "eb90b6f6e4be9dbfcca53e0a8e0f401d";

export default node;
